import React, { useEffect, useRef, useState } from "react";
// react component for creating dynamic tables
import { Redirect, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Datetime from "react-datetime";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { MailOutline } from "@material-ui/icons";
import { FormControl, Input, InputLabel } from "@material-ui/core";
import MerchantProductDialog from "components/MerchantProductDialog/MerchantProductDialog";
import { travelApi } from "functions/apis";
import CustomInput from "components/CustomInput/CustomInput";

const useStyles = makeStyles(styles);

export default function DeleteMerchantOnlineProductCost(props) {
  const source = useRef(new AbortController());
  const [redirect, setRedirect] = useState(false);
  const [payload, setPayload] = useState({
    effectiveDate: null,
    expiryDate: null
  });
  const [editData, setEditData] = useState();
  const [showProductModal, setShowProductModal] = React.useState(false);
  const [productData, setProductData] = React.useState({
    id: "",
    name: ""
  });
  const [disabled, setDisabled] = React.useState(false);

  const { id } = useParams();

  useEffect(() => {
    return () => {
      source.current.abort();
      if (payload) {
        setRedirect(true);
      }
    };
  }, []);

  useEffect(() => {
    if (id) {
      travelApi
        .get("/ProductCosts/" + id, {
          signal: source.current.signal
        })
        .then(data => {
          setEditData(data);
          setPayload({
            effectiveDate: data.effectiveDate
              ? new Date(data.effectiveDate + "Z")
              : null,
            expiryDate: data.expiryDate ? new Date(data.expiryDate + "Z") : null
          });
          setProductData(data.product);
        })
        .catch(error => console.log(error));
    }
  }, [id]);

  const handleProductIDChanged = e => {
    if (e) {
      setProductData({ id: e.id, name: e.name });
      setPayload(prev => ({
        ...prev,
        productID: e.id
      }));
      setShowProductModal(false);
    }
  };

  const handleEffectiveDateChanged = e =>
    setPayload(prev => ({
      ...prev,
      effectiveDate: e === "" ? null : e
    }));

  const handleExpiryDateChanged = e =>
    setPayload(prev => ({
      ...prev,
      expiryDate: e === "" ? null : e
    }));

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    const body = { ...payload };

    travelApi
      .delete("/ProductCosts/" + id, body, {
        signal: source.current.signal
      })
      .then(() => setRedirect(true))
      .catch(err => {
        console.log(err);
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to={"/admin/MerchantOnlineProductCost/List"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              DELETE MERCHANT ONLINE PRODUCT COST
            </h4>
          </CardHeader>
          <CardBody>
            <i>*Are you sure to delete this merchant online product?</i>
            <br />

            <form onSubmit={handleSubmit}>
              <Button onClick={() => props.history.goBack()} value="Back">
                BACK
              </Button>
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                Delete
              </Button>
            </form>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12}>
                  <FormControl
                    disabled={true}
                    fullWidth
                    className={classes.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="selAgent"
                      className={classes.selectLabel}
                    >
                      Merchant Product
                    </InputLabel>
                    <Input
                      onClick={() => setShowProductModal(prev => !prev)}
                      className={classes.select}
                      value={productData ? productData.name : ""}
                    />
                    <MerchantProductDialog
                      openModal={showProductModal}
                      setOpenModal={val => setShowProductModal(val)}
                      onSelect={handleProductIDChanged}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Variant"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: editData?.variant ? editData.variant.name : "",
                      disabled: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <div style={{ height: 12 }}></div>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <FormControl disabled={true} fullWidth>
                    <Datetime
                      value={payload.effectiveDate ?? null}
                      onChange={handleEffectiveDateChanged}
                      timeFormat={true}
                      closeOnSelect={true}
                      utc
                      inputProps={{
                        placeholder: "Effective Date"
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <FormControl disabled={true} fullWidth>
                    <Datetime
                      value={payload.expiryDate ?? null}
                      onChange={handleExpiryDateChanged}
                      timeFormat={true}
                      closeOnSelect={true}
                      utc
                      inputProps={{
                        placeholder: "Expiry Date"
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Cost"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: editData && editData.cost ? editData.cost : "",
                      type: "number",
                      disabled: true
                    }}
                  />
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

DeleteMerchantOnlineProductCost.propTypes = {
  history: PropTypes.object
};
